var _style, _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodPressure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blood-pressure_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".blood-pressure_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "blood-pressure_svg__st0",
    d: "M129.1 66c-6.6 6.6-15.6 10.6-25.6 10.6s-19-4.1-25.6-10.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "blood-pressure_svg__st0",
    cx: 103.5,
    cy: 40.4,
    r: 26.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "blood-pressure_svg__st0",
    d: "M89.5 26.3l3.6 3.6M83.7 40.4h5M89.5 54.4l3.6-3.6M103.5 60.2v-5M117.6 54.4l-3.6-3.6M123.4 40.4h-5.1M117.6 26.3l-3.6 3.6M103.5 40.4V22.9M118.3 74v11.2c0 2.9-2.4 5.3-5.3 5.3H94c-2.9 0-5.3-2.4-5.3-5.3V74M45.5 19.9c0-3.3-2.7-6-6-6s-6 2.7-6 6c0 1.8-1 3.5-2.5 4.5C9.7 38.5 20.3 64 23.5 70.6c.7 1.5 4.3 6.4 4.9 13.7.3 3.5 3.3 6.2 6.8 6.2h8.6c3.5 0 6.6-2.7 6.8-6.2.5-7.3 4.2-12.3 4.9-13.8 3.2-6.6 13.8-32.1-7.5-46.2-1.6-.9-2.5-2.6-2.5-4.4zM103.5 90.6v43.5M39.3 90.6v43.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 47.8c-5.2 4.2-11.1 7.4-17.4 9.6 1.1 4.6 2.8 8.5 3.8 10.6.1.2.2.4.4.6 1.4 2.3 4.6 7.8 5.1 15.4 0 .3.4.6.9.6h8.6c.4 0 .8-.3.8-.6.6-7.5 3.8-13 5.1-15.4.1-.2.3-.4.3-.6 2.4-4.9 8.2-18.9 2.3-30.1-2.9 3.6-6.2 7-9.9 9.9z",
    fill: "var(--color-icon-secondary)"
  })));
}
export default SvgBloodPressure;